
import { Route } from 'react-router-dom';

import ManagerRoute from '../ManagerRoute';

import RMDashboard from '../../features/dashboard/pages/RMDashboard';
import TeamActiveHours from '../../features/dashboard/pages/TeamActiveHours';
import ProductivityReport from '../../features/dashboard/pages/Manager/ProductivityReport';
import IdleTimeReport from '../../features/dashboard/pages/Manager/IdleTimeReport';
import AtRiskAssociates from '../../features/dashboard/pages/Manager/AtRiskAssociates';

const ManagerRoutes = () => {
  return (
    <>
      <Route
        path="/rm-dashboard"
        element={
          <ManagerRoute requiredRole="Manager">
            <RMDashboard />
          </ManagerRoute>
        }
      />

      <Route
        path="/team-active-hours"
        element={
          <ManagerRoute requiredRole="Manager">
            <TeamActiveHours />
          </ManagerRoute>
        }
      />

      <Route
        path="/rm-productivity-report"
        element={
          <ManagerRoute requiredRole="Manager">
            <ProductivityReport />
          </ManagerRoute>
        }
      />

      <Route
        path="/idle-time-report"
        element={
          <ManagerRoute requiredRole="Manager">
            <IdleTimeReport />
          </ManagerRoute>
        }
      />

      <Route
        path="/at-risk-associates"
        element={
          <ManagerRoute requiredRole="Manager">
            <AtRiskAssociates />
          </ManagerRoute>
        }
      />
    </>
  );
};

export default ManagerRoutes;
